import { CanDeactivateFn } from '@angular/router';
import { FleetMaintenanceComponent } from './fleet-maintenance.component';

export const FleetMaintenancePendingChangesGuard: CanDeactivateFn<FleetMaintenanceComponent> =
  (component: FleetMaintenanceComponent) => component.canDeactivate();
